module.exports = __webpack_public_path__ + "img/header_dsk.8f92aa5.jpg";